/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgBankAdd.css";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import PropTypes from "prop-types";
import { simpleFetch } from "../../restWrapper";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import errorMsg from "../../assets/json/errMsg.json";

class OrgBankAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      clearing_code: "",
      branch_code: "",
      account_number: "",
      isDefault: false,
      language: this.props.language,
      bankList: this.props.languageObj.bankList,
      selectedBank: "",

      errMsg: {
        clearing_code: "",
        branch_code: "",
        account_number: "",
        btn: "",
      },
    };
    this.backBtn = this.backBtn.bind(this);
    this.submitBtn = this.submitBtn.bind(this);

    this.handleClearingCode = this.handleInput.bind(this, "clearing_code");
    this.handleBranchCode = this.handleInput.bind(this, "branch_code");
    this.handleAccountNumber = this.handleInput.bind(this, "account_number");
    this.handleSelectBox = this.handleSelectBox.bind(this);

    this.setDefaultBtn = this.setDefaultBtn.bind(this);
  }

  componentDidMount() {
    if (!this.props.isOrgAuth) {
      this.props.history.push({
        pathname: "/OrgLogin",
      });
    }

    this.setState({
      loading: true,
    });
    simpleFetch("/organizations", "GET", {}).then((res) => {
      this.setState({
        loading: false,
      });
      if (!res.body.organizationObj.organizationName) {
        this.props.history.push({ pathname: "/OrgSettings", page: 4 });
      }


      // Get the organization type
      const organizationType =
        res.body.organizationObj.organizationType || "nonprofit";
      // console.log("OrgBankAdd: Using organization type:", organizationType);

      this.setState({
        organizationName: res.body.organizationObj.organizationName,
        organizationType: organizationType,
      });
    });
  }

  handleInput(name, e) {
    let s = e.target.value;
    if (name === "branch_code") {
      if (s.length > 3) return false;
    }
    let data = this.state;
    data[name] = s;
    data.errMsg[name] = "";
    this.setState({
      data,
    });
  }

  handleSelectBox(e) {
    let v = e.target.value;
    let state = this.state;
    state.errMsg["clearing_code"] = "";
    state.selectedBank = e.target.value;
    if (v !== null && v !== "other") {
      state.clearing_code = e.target.value;
    } else {
      state.clearing_code = "";
    }
    this.setState({
      state,
    });
  }

  backBtn() {
    this.props.history.push({ pathname: "/OrgSettings", page: 4 });
  }

  getBankList() {
    // Pass the organization type as a query parameter
    const organizationType = this.state.organizationType || "nonprofit";
    return simpleFetch(
      `/organizations/banks?organizationType=${organizationType}`,
      "GET",
    ).then((res) => {
      return res;
    });
  }

  submitBtn(ev) {
    // check input data
    if (this.state.loading) return null;
    this.setState({
      loading: true,
    });
    if (
      !this.state.clearing_code ||
      !this.state.branch_code ||
      !this.state.account_number ||
      !this.state.organizationName
    ) {
      // if error ,show err msg and return
      var err = errorMsg[this.state.language].backErr;
      let ccErr;
      let bcErr;
      let anErr;

      if (!this.state.clearing_code) {
        if (this.state.selectedBank === "other") {
          ccErr = err.clearingCodeInput;
        } else {
          ccErr = err.clearingCodeSelect;
        }
      }

      if (!this.state.branch_code) {
        bcErr = err.branch_code;
      }

      if (!this.state.account_number) {
        anErr = err.account_number;
      }
      let errMsg = this.state.errMsg;

      errMsg.clearing_code = !ccErr ? "" : ccErr;
      errMsg.branch_code = !bcErr ? "" : bcErr;
      errMsg.account_number = !anErr ? "" : anErr;
      this.setState({
        errMsg: errMsg,
        loading: false,
      });
      return false;
    }

    // Pass the organization type as a query parameter
    const organizationType = this.state.organizationType || "nonprofit";
    simpleFetch(
      `/organizations/banks/createBankAccount?organizationType=${organizationType}`,
      "POST",
      {
        country: "HK",
        currency: "hkd",
        account_holder_name: this.state.organizationName,
        account_holder_type: "company",
        routing_number: this.state.clearing_code + "-" + this.state.branch_code,
        account_number: this.state.account_number,
      },
    ).then((res) => {
      if (res.body.status) {
        window.location.reload();
        //this.props.history.push({ pathname: "/OrgSettings", page: 6 });
      }
    });

    let errMsg = this.state.errMsg;

    errMsg.clearing_code = "You have not entered a valid clearing code.";
    errMsg.branch_code = "You have not entered a valid branch code.";
    errMsg.account_number = "You have not entered a valid account number.";

    this.setState({
      errMsg: errMsg,
    });
  }

  setDefaultBtn(e) {
    let bool = !this.state.isDefault;
    this.setState({
      isDefault: bool,
    });
  }

  renderStatusBtn() {
    const defaultColor = this.state.isDefault
      ? { color: "#000" }
      : { background: "#E3E3E3" };
    return (
      <div
        className="OrgBankAdd-defaultBtn"
        style={defaultColor}
        onClick={this.setDefaultBtn}
      ></div>
    );
  }
  renderCCInput(textObj) {
    if (this.state.selectedBank !== "other") return;
    return (
      <div>
        <div className="OrgBankAdd-inputFieldContainer">
          <input
            type="text"
            className="OrgBankAdd-inputField"
            value={this.state.clearing_code}
            onChange={this.handleClearingCode}
            placeholder={textObj.inputField}
          />
          {renderErrorMsg(this.state.errMsg.clearing_code)}
        </div>
        <div className="OrgBankAdd-subheading">
          <a
            style={{ color: "#2482C4" }}
            rel="noopener noreferrer"
            href="https://www.hkicl.com.hk/eng/information_centre/clearing_code_and_branch_code_list.php"
            target="_blank"
          >
            {textObj.subheading}
          </a>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="OrgBankAdd-emptyPage">
          <div className="OrgBankAdd-center">
            <div className="OrgBankAdd-btm-load"></div>
          </div>
        </div>
      );
    }

    const languageObj = this.props.languageObj;

    return (
      <div className="OrgBankAdd-view">
        <div className="OrgBankAdd-prompt">
          <div className="OrgBankAdd-header">
            <div onClick={this.backBtn} className="OrgBankAdd-back">
              <div className="OrgBankAdd-backBtn"></div>
              <div className="OrgBankAdd-backText">{languageObj.backText}</div>
            </div>

            {this.renderStatusBtn()}
          </div>

          <div className="OrgBankAdd-container">
            <div className="OrgBankAdd-heading">{languageObj.heading}</div>

            <div className="OrgBankAdd-subheading">
              {languageObj.subheading[1]}
            </div>
            <div className="OrgBankAdd-inputFieldContainer">
              <select
                className="OrgBankAdd-inputField"
                value={this.state.selectedBank}
                onChange={this.handleSelectBox}
              >
                {this.state.bankList.map((bank) => (
                  <option key={bank[1] + bank[0]} value={bank[1]}>
                    {bank[0]}
                  </option>
                ))}
              </select>
              {renderErrorMsg(
                this.state.selectedBank !== "other"
                  ? this.state.errMsg.clearing_code
                  : "",
              )}
            </div>

            {this.renderCCInput(languageObj.CCInput)}

            <div className="OrgBankAdd-subheading">
              {languageObj.subheading[2]}
            </div>
            <div className="OrgBankAdd-inputFieldContainer">
              <input
                type="text"
                className="OrgBankAdd-inputField"
                value={this.state.branch_code}
                onChange={this.handleBranchCode}
                placeholder={languageObj.inputField[0]}
              />
              {renderErrorMsg(this.state.errMsg.branch_code)}
            </div>

            <div className="OrgBankAdd-subheading">
              {languageObj.subheading[3]}
            </div>
            <div className="OrgBankAdd-inputFieldContainer">
              <input
                type="text"
                className="OrgBankAdd-inputField"
                value={this.state.account_number}
                onChange={this.handleAccountNumber}
                placeholder={languageObj.inputField[1]}
              />
              {renderErrorMsg(this.state.errMsg.account_number)}
            </div>

            {renderErrorMsg(this.state.errMsg.btn)}
            <div className="OrgBankAdd-submitBtn" onClick={this.submitBtn}>
              {languageObj.submitBtn}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OrgBankAdd.propTypes = {
  stripe: PropTypes.object.isRequired,
  isOrgAuth: PropTypes.bool,
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

// Wrapper component to use Stripe hooks with class component
function OrgBankAddWithStripe(props) {
  const stripe = useStripe();
  const elements = useElements();

  return <OrgBankAdd {...props} stripe={stripe} elements={elements} />;
}

export default OrgBankAddWithStripe;
